























































import {Vue, Component} from 'vue-property-decorator';
import MailService from "@/services/MailService";
import {processError} from "@/utils/ComponentUtils";
import RouteNames from "@/router/RouteNames";
import {WORKSPACE_ID, WORKSPACE_TYPE} from "@/constants/Paths";

@Component({})
export default class Unsubscribe extends Vue {
	private isProcessing = false;
	private success = false;
	private errorMessage = '';
	private showAccountSettingsLink = false;

	get token(): string | null {
		return (this.$route.query.token as string) || null;
	}

	get accountSettingsPath(): string {
		return '/login';
	}

	public mounted(): void {
		if (!this.token) {
			this.errorMessage = this.$t('mail.unsubscribe.error_no_token') as string;
			this.showAccountSettingsLink = true;
		}
	}

	private async unsubscribeFromAdvertising(): Promise<void> {
		if (!this.token) {
			this.errorMessage = this.$t('mail.unsubscribe.error_no_token') as string;
			this.showAccountSettingsLink = true;
			return;
		}

		this.isProcessing = true;
		this.errorMessage = '';
		this.showAccountSettingsLink = false;

		try {
			await MailService.unsubscribeFromAdvertising(this.token);
			this.success = true;
			this.errorMessage = '';
		} catch (error: any) {
			const systemCode = error?.response?.data?.systemCode;
			
			if (systemCode === 4044) {
				this.errorMessage = this.$t('mail.unsubscribe.error_invalid_token') as string;
				this.showAccountSettingsLink = true;
			} else if (systemCode === 4031) {
				alert(this.$t('mail.unsubscribe.error_expired_token_alert') as string);
				this.errorMessage = this.$t('mail.unsubscribe.error_expired_token') as string;
				this.showAccountSettingsLink = true;
			} else if (systemCode === 4091) {
				this.errorMessage = this.$t('mail.unsubscribe.error_used_token') as string;
				this.showAccountSettingsLink = true;
			} else {
				processError(error, this);
			}
		} finally {
			this.isProcessing = false;
		}
	}

	private toProfile() {
		localStorage.setItem("backUrl", `/userprofile/:${WORKSPACE_TYPE}/:${WORKSPACE_ID}/account`)
		this.$router.push(
			{
				name: RouteNames.PROFILE_ACCOUNT
			}
		);
	}

	private unsubscribeFromAll(): void {
		this.unsubscribeFromAdvertising()
		this.toProfile()
	}
}
